export const getLocalPathWithParams = (href: string): string => {
  const url = new URL(href);
  return url.pathname + url.search;
};
